export enum RequirementType {
  STATIC_ACCELERATION = 'static_acceleration',
  DYNAMIC_INPUT = 'dynamic_input',
  DRIVE_CYCLE = 'drive_cycle',
}
